import { Box } from '@material-ui/core';
import { userroles } from '../../../constants';
import useLandingChart from '../../../../hooks/useLandingChart';
import { getColor } from '../../common/helpers';
import MonthsEmpChart from '../MonthsEmpChart';

function MonthEmplSales({ isRTL, theme, systemcolor, color, height }) {
  const { salesMonth } = useLandingChart(null);
  const clr = getColor({ theme, color, systemcolor });

  return (
    <Box>
      {salesMonth && userroles?.invoices?.admin && (
        <MonthsEmpChart
          data={salesMonth}
          isRTL={isRTL}
          color={clr}
          employee={true}
          title={
            isRTL ? 'مبيعات هذا الشهر بحسب الموظف' : 'Month Sales - Employee'
          }
          height={height}
        ></MonthsEmpChart>
      )}
    </Box>
  );
}

export default MonthEmplSales;
